import { totalReachConfig } from './../totalReach';
import { SIZE_50 } from '@/lib/gridElements/size';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { KPI_VALUE_CLASSIC } from '@/utils/hooks/format/useFormatKpiValue';

// Components
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';
import { KPIDefault } from '@/components/base/Kpi/KpiDefault';

// Types
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';

export const mediaViewerReachConfig: KpiType<typeof MediaViewerKpiLoader, typeof KPIDefault> = {
    ...totalReachConfig,
    size: SIZE_50,
    name: 'kpi.linkedin.mediaviewer.reach',
    tooltip: null,
    type: 'kpi',
    data_format: KPI_VALUE_CLASSIC,
    orientation: ORIENTATION_VERTICAL,
    loader: MediaViewerKpiLoader
};
